<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :title="title"
    show-close
    width="600px"
    :close-on-click-modal="false"
    :before-close="() => $refs.editForm.cancel()"
    v-el-dialog-drag
    class="backfill-dialog"
  >
    <EditForm
      ref="editForm"
      :waybillDetailCode="waybillDetailCode"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button @click="() => $refs.editForm.cancel()">取消</el-button>
      <el-button type="primary" size="small" @click="() => $refs.editForm.save()">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    waybillDetailCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
  .backfill-dialog {
    padding-bottom: 10px;
  }
</style>
